module.exports = __webpack_public_path__ + "img/鲁健.aa19522a.jpg";